import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExternalLink } from "@/components/UI/ExternalLink";
import { FooterIcon } from "@/components/Layout/footer/FooterIcon";
import {
  getCompanyAboutUrl,
  getCompanyContactsUrl,
  getCompanyUrl,
} from "@/constants/contact";
import { useLanguage } from "@/hooks/useLanguage";
import {
  FOOTER_CONTACT_ITEMS,
  FOOTER_CONTACTS_TITLE_KEY,
} from "@/components/Layout/footer/footerData";
import type { FooterContactItem } from "@/components/Layout/footer/footerData";
import "./FooterContacts.css";

function FooterContactLink({ item }: { item: FooterContactItem }) {
  const { t } = useTranslation();
  const { lang } = useLanguage();
  const content = (
    <>
      <FooterIcon name={item.icon} />
      {t(item.labelKey)}
    </>
  );

  if (item.type === "internal") {
    return (
      <Link to={item.to} className="site-footer__contact-link muted">
        {content}
      </Link>
    );
  }

  const href = item.id === "contacts"
    ? getCompanyContactsUrl(lang)
    : getCompanyAboutUrl(lang);

  return (
    <ExternalLink href={href} className="site-footer__contact-link muted">
      {content}
    </ExternalLink>
  );
}

export function FooterContacts() {
  const { t } = useTranslation();
  const { lang } = useLanguage();

  return (
    <section
      className="site-footer__contacts"
      aria-labelledby="site-footer-contacts-title"
    >
      <h2
        id="site-footer-contacts-title"
        className="site-footer__contacts-title"
      >
        <ExternalLink
          href={getCompanyUrl(lang)}
          className="site-footer__contacts-title-link"
        >
          {t(FOOTER_CONTACTS_TITLE_KEY)}
        </ExternalLink>
      </h2>
      <ul className="site-footer__contact-list">
        {FOOTER_CONTACT_ITEMS.map((item) => (
          <li key={item.id} className="site-footer__contact-item">
            <FooterContactLink item={item} />
          </li>
        ))}
      </ul>
    </section>
  );
}
